<template>
  <div class="tfDimensional">
    <div class="content">
      <ul class="ul">
        <li class="li" v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
            <div class="layer">
              {{ item.desc }}
            </div>
          </div>
          <!-- <div class="name">
            {{ item.name }}
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tfDimensional',
  data() {
    return {
      imgList: [
        {
          img: require('./img/2.5d_1.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        },
        {
          img: require('./img/2.5d_2.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        },
        {
          img: require('./img/2.5d_3.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        },
        {
          img: require('./img/2.5d_4.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        },
        {
          img: require('./img/2.5d_5.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        },
        {
          img: require('./img/2.5d_6.jpg'),
          name: '2.5维地图',
          desc: '将二维地图栅格化展示形式与三维真实场景视觉效果结合，既降低对计算机性能要求，又能感受真实三维场景，增强用户体验感。'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.tfDimensional {
  .content {
    width: 1920px;
    min-height: 950px;
    background: #ffffff;
    // border: 1px solid #979797;
    margin: 0 auto;
    .ul {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      min-height: 850px;
      padding: 45px 240px 0 240px;
      justify-content: space-between;
      .li {
        margin-top: 45px;
        text-align: center;
        .img {
          width: 416px;
          height: 234px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .layer {
            position: absolute;
            left: 0;
            bottom: -165px;
            width: 100%;
            height: 165px;
            transition: 0.5s;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-family: 'PingFang';
            font-size: 22px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 23px 58px 0 39px;
            text-align: left;
          }
        }
        .name {
          margin-top: 18px;
          font-size: 26px;
          font-family: 'PingFang';
          font-weight: bold;
          color: #000000;
        }
        // &:hover {
        //   .img {
        //     .layer {
        //       bottom: 0;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
